import * as constants from '../constants';

export const propertyValueRequest = (nodeId, propId, value) => ({type: constants.PROPERTY_VALUE_REQUEST, payload: {nodeId, propId, value}});
export const propertyValueUpdate = (payload) => ({type: constants.PROPERTY_VALUE_UPDATE, payload});
